import React, { Component } from 'react';
import axios from "axios";
import { API_URL, ERROR_HANDLE } from "config/constants";
import theme from '../../../../Theme/theme';
import Spinner from '../../../../components/LoadingSpinner';

const ACTIVE_PROMPT_TILES = "Active Prompt Tiles"

class PromptTiles extends Component {
    constructor(props) {
        super(props);
        this.state = {
            promptTiles: [],
            isLoading: true,
            selectedTile: {}
        }
    }

    componentDidMount() {
        this.getPromptTilesApiCall();
    }

    getPromptTilesApiCall() {
        const access_token = localStorage.getItem("access_token");
        axios
            .get(`${API_URL}/admin/promptTiles`, {
                headers: {
                    "x-access-token": access_token
                }
            }).then(res => {
                if (!res.error) {
                    this.setState({
                        promptTiles: res.data
                    })
                } else {
                    if (res.error === 'Invalid Auth Token') {
                        window.location.assign("/");
                    }
                }
                this.setState({ isLoading: false });
            })
            .catch(err => {
                ERROR_HANDLE(err);
                this.setState({ isLoading: false });
            });
    }

    updatePromptTileApiCall(tile) {
        let promptTiles = [];
        promptTiles.push({ id: tile.id, isActive: false })
        promptTiles.push({ id: this.state.selectedTile.id, isActive: true })

        const access_token = localStorage.getItem('access_token');
        axios
            .post(`${API_URL}/admin/promptTiles`, {
                promptTiles,
                adminUser: "FlexitAdmin"
            }, {
                    headers: {
                        'x-access-token': access_token
                    }
                }
            )
            .then(res => {
                if (!res.error) {
                    //success
                    this.updateActivePromptTile(tile)
                } else {
                    if (res.error === 'Invalid Auth Token') {
                        window.location.assign("/");
                    }
                }
                this.setState({ isLoading: false });
            })
            .catch(err => {
                ERROR_HANDLE(err);
                this.setState({ isLoading: false });
            });
    }

    updateActivePromptTile = (tile) => {
        //update the selected Tile value
        const tileValue = this.state.promptTiles.find(tileValue => tileValue.id === tile.id)
        const selectedTileValue = this.state.promptTiles.find(tileValue => tileValue.id === this.state.selectedTile.id)
        if (tileValue != null && selectedTileValue != null) {
            tileValue.isActive = false
            selectedTileValue.isActive = true
            //swap the promptTiles
            this.setState(prevState => {
                const tileIndex = this.state.promptTiles.findIndex(tileValue => tileValue.id === tile.id)
                const selectedTileIndex = this.state.promptTiles.findIndex(tileValue => tileValue.id === this.state.selectedTile.id)
                let promptTiles = [...prevState.promptTiles];
                let tempPromptTile = promptTiles[tileIndex];
                promptTiles[tileIndex] = promptTiles[selectedTileIndex];
                promptTiles[selectedTileIndex] = tempPromptTile;
                return { promptTiles };
            }, () => {
                this.setState({
                    selectedTile: {}
                })
            })
        }
    }

    getActivePromptTiles(isEditable) {
        var activeTilesArray = [];
        this.state.promptTiles && this.state.promptTiles.forEach((tile, index) => {
            const enableEditOption = this.state.selectedTile.id && tile.isEditable ? true : false
            const selectedStyle = { backgroundColor: enableEditOption ? theme.color.primaryBlue : theme.color.tilesThickGrey }
            tile.isActive && tile.isEditable === isEditable && activeTilesArray.push(
                <div key={"activePromptTile" + index} style={style.promptTile} onClick={() => { enableEditOption && this.updatePromptTileApiCall(tile) }}>
                    <div style={{ ...style.promptTileBox, ...selectedStyle }} >
                        <div style={style.promptTileText}>{tile.name.toUpperCase()} </div>
                        <div style={style.promptTileIconContainer}>
                            <img src={tile.icon} alt="" style={style.promptTileIcon} />
                        </div>
                    </div>
                </div>
            );
        });
        return activeTilesArray;
    }

    getInActivePromptTiles() {
        var inActiveTilesArray = [];
        this.state.promptTiles && this.state.promptTiles.forEach((tile, index) => {
            const selectedStyle = { backgroundColor: this.state.selectedTile.id && this.state.selectedTile.id === tile.id ? theme.color.black : theme.color.tilesLightGrey }
            !tile.isActive && inActiveTilesArray.push(
                <div key={"inactivePromptTile" + index} style={{ ...style.promptTile, ...{ width: 78 } }}>
                    <div style={{ ...style.promptTileBox, ...selectedStyle, ...{ width: 73, height: 73 } }} onClick={() => { this.setState({ selectedTile: tile }) }}>
                        <div style={{ ...style.promptTileText, ...{ fontSize: 9 } }}>{tile.name.toUpperCase()} </div>
                        <div style={style.promptTileIconContainer}>
                            <img src={tile.icon} alt="" style={style.promptTileIcon} />
                        </div>
                    </div>
                </div>
            );
        });
        return inActiveTilesArray
    }

    renderPromptList() {
        return (
            <div style={style.flexAlignSpaceBetween}>
                <div style={style.promptTilesActiveContainer}>
                    {this.getActivePromptTiles(false)}
                    {this.getActivePromptTiles(true)}
                    <div style={style.activePromptText}>{ACTIVE_PROMPT_TILES}</div>
                </div>
                <div style={style.promptTilesInActiveContainer}>
                    {this.getInActivePromptTiles()}
                </div>
            </div >);
    }

    render() {
        return (
            this.state.isLoading ? <Spinner loading={this.state.isLoading} /> :
                this.renderPromptList()
        )
    }
}

const style = {
    flexAlignSpaceBetween: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: 'flex-start',
        marginTop: 30
    },
    promptTilesActiveContainer: {
        display: "flex",
        width: 300,
        flexWrap: 'wrap',
        justifyContent: 'center',
        borderRight: "4px solid " + theme.color.primaryBlue,
        paddingRight: 5
    },
    promptTilesInActiveContainer: {
        display: "flex",
        width: 270,
        flexWrap: 'wrap',
        justifyContent: 'center',
        borderRight: "4px solid " + theme.color.tableSeparatorGrey,
        paddingLeft: 5
    },
    promptTile: {
        width: 90,
        marginBottom: 15,
        marginHorizontal: 8
    },
    promptTileBox: {
        height: 85,
        width: 85,
        backgroundColor: theme.color.primaryBlue,
        borderRadius: 8,
        display: "flex",
        flexDirection: "column-reverse",
        alignItems: 'center',
        justifyContent: 'center',
        shadowColor: theme.black,
        shadowOffset: { width: 1, height: 1 },
        shadowOpacity: 0.5,
        shadowRadius: 2,
        elevation: 1
    },
    promptTileIconContainer: {
        width: "60%",
        height: "60%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    },
    promptTileIcon: {
        maxWidth: "100%",
        maxHeight: "100%"
    },
    promptTileText: {
        fontSize: 10,
        fontFamily: theme.font.glacialIndifference,
        fontStyle: theme.fontWeight.regular,
        fontWeight: theme.fontWeight.regular,
        color: theme.color.white,
        textAlign: 'center',
        marginTop: 2,
        height: 20,
        display: "flex",
        alignItems: "center",
        paddingLeft: 2,
        paddingRight: 2
    },
    activePromptText: {
        fontSize: 20,
        fontFamily: theme.font.glacialIndifference,
        fontWeight: theme.fontWeight.bold,
        fontStyle: theme.fontWeight.regular,
        color: theme.color.thickGrey,
        textAlign: 'center'
    }
};

export default PromptTiles;

